import { ICreateRequest } from '../entities/services';
import { ProjectHelper } from '@bimser/common';

export function CreateForm(data: ICreateRequest) {
	return ProjectHelper.RunPromiseFormService({
		projectName: data.projectName,
		formName: data.formName,
		serviceName: 'Create',
		requestParameters: { secretKey: data.secretKey },
		projectVersion: data.projectVersion
	});
}
